__turbopack_context__.v({
  "arrowDownIcon": "styles-module-scss-module__UcvSiW__arrowDownIcon",
  "footerLinksContent": "styles-module-scss-module__UcvSiW__footerLinksContent",
  "headingLink": "styles-module-scss-module__UcvSiW__headingLink",
  "headingLinkWithChild": "styles-module-scss-module__UcvSiW__headingLinkWithChild",
  "hiddenFooterLinks": "styles-module-scss-module__UcvSiW__hiddenFooterLinks",
  "hiddenMenuContainer": "styles-module-scss-module__UcvSiW__hiddenMenuContainer",
  "menu1": "styles-module-scss-module__UcvSiW__menu1",
  "readmoreCTA": "styles-module-scss-module__UcvSiW__readmoreCTA",
  "showFooterLinks": "styles-module-scss-module__UcvSiW__showFooterLinks",
  "showLessArrow": "styles-module-scss-module__UcvSiW__showLessArrow",
  "showMoreArrow": "styles-module-scss-module__UcvSiW__showMoreArrow",
  "showMoreButton": "styles-module-scss-module__UcvSiW__showMoreButton",
  "subMenuItem": "styles-module-scss-module__UcvSiW__subMenuItem",
});
